import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";

import Login from "./pages/Login";
import Admin from "./pages/Admin";
import Kassa from "./pages/Kassa";
import KassaSuccess from "./pages/KassaSuccess";
import KassaSumUpCallback from "./pages/KassaSumUpCallback";
import KassaSumUpSoloPoll from "./pages/KassaSumUpSoloPoll";
import Voorbereider from "./pages/Voorbereider";
import Pickup from "./pages/Pickup";
import Live from "./pages/Live";
import Setup from "./pages/Setup";
import { getAuth } from "./lib/auth";
import { flushQueue } from "./lib/offlineQueue";
import { loadBranding } from "./lib/branding";

function Protected({ roles, children }) {
  const a = getAuth();
  if (!a) return <Navigate to="/" replace />;
  if (roles && !roles.includes(a.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  const [brandingReady, setBrandingReady] = useState(false);

  useEffect(() => {
    loadBranding().finally(() => setBrandingReady(true));
  }, []);

  useEffect(() => {
    const sync = () => {
      if (navigator.onLine) flushQueue().catch(() => {});
    };
    sync();
    window.addEventListener("online", sync);
    const id = setInterval(sync, 15000);
    return () => {
      window.removeEventListener("online", sync);
      clearInterval(id);
    };
  }, []);

  if (!brandingReady) {
    return <div className="min-h-screen flex items-center justify-center text-[var(--ink-soft)]">Laden…</div>;
  }

  return (
    <div className="App">
      <Toaster position="bottom-right" richColors expand={true} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/admin"
            element={
              <Protected roles={["admin"]}>
                <Admin />
              </Protected>
            }
          />
          <Route
            path="/kassa"
            element={
              <Protected roles={["admin", "kassa"]}>
                <Kassa />
              </Protected>
            }
          />
          <Route
            path="/kassa/success"
            element={
              <Protected roles={["admin", "kassa"]}>
                <KassaSuccess />
              </Protected>
            }
          />
          <Route path="/kassa/sumup-callback" element={<KassaSumUpCallback />} />
          <Route
            path="/kassa/sumup-solo/:orderId"
            element={
              <Protected roles={["admin", "kassa"]}>
                <KassaSumUpSoloPoll />
              </Protected>
            }
          />
          <Route
            path="/voorbereider"
            element={
              <Protected roles={["admin", "voorbereider"]}>
                <Voorbereider />
              </Protected>
            }
          />
          <Route path="/pickup" element={<Pickup />} />
          <Route path="/live" element={<Live />} />
          <Route path="/setup" element={<Setup />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
